import { render, staticRenderFns } from "./configCompetitorFile.vue?vue&type=template&id=ef00db32&scoped=true"
import script from "./configCompetitorFile.vue?vue&type=script&lang=js"
export * from "./configCompetitorFile.vue?vue&type=script&lang=js"
import style0 from "./configCompetitorFile.vue?vue&type=style&index=0&id=ef00db32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef00db32",
  null
  
)

export default component.exports